import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { accessGuard, authGuard, guestGuard } from './core/guards';

const allowed = (permission?: string, roles?: string[]) => ({ canActivate: [accessGuard], data: { permission, roles } });

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./features/auth/login.component').then((m) => m.LoginComponent),
  },
  // Catálogo de la librería ui (solo fuera de producción, sin sesión)
  ...(environment.production ? [] : [
    { path: 'dev/ui', loadComponent: () => import('./dev/dev-ui.component').then((m) => m.DevUiComponent) },
  ]),
  {
    path: 'auth/microsoft/callback',
    loadComponent: () => import('./features/auth/microsoft-callback.component').then((m) => m.MicrosoftCallbackComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/shell.component').then((m) => m.ShellComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'inicio' },
      { path: 'inicio', loadComponent: () => import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent) },
      {
        path: 'base-datos', ...allowed('contacts.view'),
        loadChildren: () => import('./features/crm/crm.routes').then((m) => m.CRM_ROUTES),
      },
      {
        path: 'enriquecimiento', ...allowed('contacts.view'),
        loadComponent: () => import('./features/enrichment/enrichment.component').then((m) => m.EnrichmentComponent),
      },
      {
        path: 'campanas', ...allowed('campaigns.view'),
        loadChildren: () => import('./features/campaigns/campaigns.routes').then((m) => m.CAMPAIGN_ROUTES),
      },
      {
        path: 'integraciones', ...allowed('integrations.view'),
        loadComponent: () => import('./features/integrations/integrations.component').then((m) => m.IntegrationsComponent),
      },
      {
        path: 'verificador', ...allowed('contacts.view'),
        loadComponent: () => import('./features/verifier/verifier.component').then((m) => m.VerifierComponent),
      },
      {
        path: 'plantillas', ...allowed('campaigns.view'),
        loadComponent: () => import('./features/templates/templates.component').then((m) => m.TemplatesComponent),
      },
      {
        path: 'analitica', ...allowed('campaigns.view'),
        loadComponent: () => import('./features/analytics/analytics.component').then((m) => m.AnalyticsComponent),
      },
      {
        path: 'equipo', ...allowed('users.view'),
        loadComponent: () => import('./features/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'empresas', ...allowed('companies.view'),
        loadComponent: () => import('./features/companies/companies.component').then((m) => m.CompaniesComponent),
      },
      { path: 'configuracion', loadComponent: () => import('./features/settings/settings.component').then((m) => m.SettingsComponent) },
      { path: 'ayuda', loadComponent: () => import('./features/help/help.component').then((m) => m.HelpComponent) },

      // Rutas antiguas
      { path: 'dashboard', redirectTo: 'inicio' },
      { path: 'campaigns', redirectTo: 'campanas' },
      { path: 'campaigns/new', redirectTo: 'campanas/nueva' },
      { path: 'integrations', redirectTo: 'integraciones' },
      { path: 'users', redirectTo: 'equipo' },
      { path: 'companies', redirectTo: 'empresas' },
      { path: 'email-accounts', redirectTo: 'configuracion' },
      { path: 'n8n', redirectTo: 'configuracion' },
    ],
  },
  { path: '**', redirectTo: '' },
];
